module.exports = __webpack_public_path__ + "static/media/bgw.5cdccf6a.png";